import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";
import { useLang } from "@/i18n";

const norm = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const AccountPicker = ({ value, onChange, accounts, testId }) => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const selected = accounts.find((a) => a.code === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" data-testid={testId}
          className={cn("h-9 w-full inline-flex items-center justify-between gap-2 rounded-md border px-3 text-sm bg-white dark:bg-slate-950 text-left",
            selected ? "border-slate-200 dark:border-slate-700" : "border-amber-400 text-slate-500")}>
          <span className="truncate">{selected ? <><span className="font-mono">{selected.code}</span> · {selected.name}</> : t("select_account")}</span>
          <ChevronsUpDown size={14} className="shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[420px] p-0" align="start">
        <Command filter={(v, s) => (norm(v).includes(norm(s)) ? 1 : 0)}>
          <CommandInput placeholder={t("search_account")} data-testid={`${testId}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>{t("no_results")}</CommandEmpty>
            <CommandGroup>
              {accounts.map((a) => (
                <CommandItem key={a.code} value={`${a.code} ${a.name}`} onSelect={() => { onChange(a.code); setOpen(false); }} data-testid={`${testId}-option-${a.code}`}>
                  <Check size={14} className={cn("mr-2", value === a.code ? "opacity-100" : "opacity-0")} />
                  <span className="font-mono mr-2 text-slate-600 dark:text-slate-300">{a.code}</span>
                  <span className="truncate">{a.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
